var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"section-loader-overlay",class:{ withBackground :!_vm.noBackground }},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-loader-wrapper"},[_c('span',{staticClass:"mdi mdi-loading mdi-spin spin"})])
}]

export { render, staticRenderFns }